import React, { useEffect } from 'react';
import QRCode from 'react-qr-code';
import PropTypes from 'prop-types';

import { IntlManager, NotificationManager, useApplicationState } from '@atlas/core';
import { Label } from '@atlas/ui';

import TerminalQrCodePopup from 'src/terminal/popups/TerminalQrCodePopup';

const TerminalPixDepositPopup = ({ data, id }) => {
  const { authenticated, resolved } = useApplicationState();
  const { amount, redirectUrl, text, title } = data;
  const formattedAmount = IntlManager.formatMoney(amount);

  useEffect(() => {
    if (resolved && !authenticated) {
      NotificationManager.removeNotification(id);
    }
  }, [resolved, authenticated, id]);

  return (
    <TerminalQrCodePopup
      className="terminal-pix-deposit-modal"
      footer={
        <div className="terminal-pix-amount">
          <Label message="terminal_pix_popup_amount" />
          <span className="bold">{formattedAmount}</span>
        </div>
      }
      id={id}
      qrCode={<QRCode size={240} value={redirectUrl} />}
      text={text}
      title={title}
    />
  );
};

TerminalPixDepositPopup.propTypes = {
  data: PropTypes.shape({
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    redirectUrl: PropTypes.string,
    text: PropTypes.string,
    title: PropTypes.string,
  }),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default TerminalPixDepositPopup;
